import dayjs from 'dayjs'
import { getCurrentDayRelativeMilliSeconds } from '@/utils/index'
import {
  ClientJijiaInsuranceListItem,
  DeviceJijiaInsuranceInfo,
  ClientJijiaInsuranceDetail,
} from '@/types/insurance'

export function getActivedDayValue(time: number, currentTimeValue = Date.now()): number {
  // currentTimeValue是计算的基准，默认以计算的当前时间，单位是毫秒
  const timeValue = time * 1000
  // const currentTimeValue = Date.now()
  const ratio = (currentTimeValue - timeValue) / 86400000
  let dayValue = 0
  if (ratio < 1) {
    dayValue = 1
  } else {
    // 多于1的情况，判断如何取整
    const currentRelativeTime = getCurrentDayRelativeMilliSeconds(currentTimeValue)
    const activeRelativeTime = getCurrentDayRelativeMilliSeconds(timeValue)
    if (currentRelativeTime <= activeRelativeTime) {
      // 向下取整  例如今天11:00   后天10:00 这时需要算2天
      dayValue = Math.ceil(ratio)
    } else {
      dayValue = Math.floor(ratio)
    }
  }
  return dayValue
}
export function getActiveTimeInfo(time: number): string[] {
  // time是秒的时间戳
  const timeValue = time * 1000
  const dayValue = getActivedDayValue(time)
  return [`激活时间：${dayjs(timeValue).format('YYYY-MM-DD')}`, `激活${dayValue}天`]
}

export function getInsuranceStatusClassName(status: number, status_desc: string): string {
  let className = 'disabled'
  if (status === 1) {
    className = 'warning'
  } else if (status === 2) {
    className = 'success'
    if (status_desc === '未生效') {
      className = 'warning'
    } else if (status_desc.indexOf('已失效') !== -1) {
      className = 'disabled'
    }
  }
  return className
}

export function getInsuranceStatusDesc(status: number, status_desc: string): string {
  if (status === 6 || status === 5 || status_desc.indexOf('已失效') !== -1) {
    return '已失效'
  } else if (status === 7 || status === 8) {
    return '已退保'
  } else if (status === 11) {
    return '已撤销'
  } else if (status_desc === '未生效') {
    return '待生效'
  }
  return status_desc
}
// 是否可批改被保人，由后端 correct_status 决定（1 不可批改，2 可批改）
export function judgeInsuranceItemCanCorrect(data: ClientJijiaInsuranceListItem): boolean {
  return data?.operation?.correct_status === 2
}

/** 三者险列表：status 1 → 3 → 2，其余靠后 */
export function getThirdPartyInsuranceStatusSortWeight(status?: number): number {
  const order: Record<number, number> = { 1: 0, 3: 1, 2: 2 }
  return order[status ?? -1] ?? 99
}

/** 机身险批改列表：已生效靠前，灰色(disabled)靠后 */
export function getJijiaInsuranceCorrectListSortWeight(status: number, status_desc: string): number {
  const desc = getInsuranceStatusDesc(status, status_desc)
  const className = getInsuranceStatusClassName(status, status_desc)
  if (className === 'disabled') {
    return 100
  }
  if (desc === '已生效') {
    return 0
  }
  if (desc === '待生效') {
    return 10
  }
  if (status === 1) {
    return 20
  }
  return 50
}
// 是否可退保
export function judgeJijiaInsuranceCanRefund(data: ClientJijiaInsuranceListItem): boolean {
  return (
    data.status === 2 &&
    // dayjs(data.policy_end_at).valueOf() > Date.now() &&
    // data.status_desc.indexOf('已失效') === -1
    (data?.operation?.operation_status === 2 || data?.operation?.operation_status === 0)
  ) // 部分特殊情况，状态码还没跑脚本更新但已经失效了
}

// 是否需要判断可加保
export function judgeJijiaInsuranceNeedCheckQuotaReplenishment(
  data: ClientJijiaInsuranceDetail
): boolean {
  // 已生效 或者 额度为0已失效，2026产品，非见费且首保的。可以检查是否能加保
  return (
    (data.status === 2 || data.status === 6) &&
    data.product_info?.pro_version === '2026' &&
    (data?.order_type === '非见费' || String(data?.order_type) === '2') &&
    data?.insurance_type === 1 &&
    data?.cycle_year === 1
  )
}

// 通过产品服务信息判断是否可加保
export function judgeJijiaInsuranceDeviceCanQuotaReplenishment(
  deiveItem: DeviceJijiaInsuranceInfo
): boolean {
  return deiveItem?.cycle_year === 1 && deiveItem?.insurance_type === 2
}

export function judgeJijiaInsuranceCanDonwload(data: ClientJijiaInsuranceListItem): boolean {
  // 是否可下载保单
  return data?.operation?.download_status === 1
}

// 保单列表能否显示更多
export function judgeInsuranceItemCanShowMore(data: ClientJijiaInsuranceListItem): boolean {
  return judgeJijiaInsuranceCanRefund(data) || judgeJijiaInsuranceCanDonwload(data)
}

export function getStatusBgColor(status_text: string) {
  if (
    status_text === '已过期' ||
    status_text === '已失效-额度为0' ||
    status_text === '已失效-保险过期'
  ) {
    return 'rgba(247,152,28,1)'
  } else if (status_text === '无服务') {
    return 'rgba(0,0,0,0.22)'
  }
  return 'rgba(57, 181, 74, 1)'
}
